import axios from 'axios';
import { IS_MOCK_API } from '../comm/config';

const URL = '/wpenv';

const envP = {
  DEV: 'DEV',
  SIT: 'SIT',
  FIX_SIT: 'FIX_SIT',
  UAT: 'UAT',
  FIX_UAT: 'FIX_UAT',
  PPS: 'PPS',
  PRD: 'PROD',
};
let environments = envP.PRD;
let loaded = false;
const urls = {
  [envP.DEV]: 'https://idman-corp-dev/BSD/Hotline/Logon.asp',
  [envP.SIT]: 'https://idman-corp-dev/BSD_SYS/Hotline/Logon.asp',
  [envP.FIX_SIT]: 'https://idman-corp-dev/BSD_SYS/Hotline/Logon.asp',
  [envP.UAT]: 'https://idman-corp-dev/BSD_UAT/Hotline/Logon.asp',
  [envP.FIX_UAT]: 'https://idman-corp-dev/BSD_UAT/Hotline/Logon.asp',
  [envP.PPS]: 'https://idman-corp-dev/BSD_UAT/Hotline/Logon.asp',
  [envP.PRD]: 'https://wcdciis02/bsd/hotline/Logon.asp',
};

const envFunc = {
  getRequest: async function () {
    let result = null;
    if (IS_MOCK_API) {
      result = { data: envP.SIT };
    } else {
      result = await axios.get(URL);
      loaded = true;
    }
    return result?.data;
  },
  setEnv: async function () {
    try {
      if(!loaded){
        const result = await this.getRequest();
        const temp = Object.values(envP).find((item) => {
          return result?.toUpperCase()?.includes(item) ?? false;
        });
        if (temp) {
          environments = temp;
        } else {
          environments = envP.PRD;
        }
      }
    } catch {
      environments = envP.PRD;
    }
  },
  getEnv: async function () {
    await this.setEnv();
    return environments;
  },
  getEnvLoginUrl: async function () {
    await this.setEnv();
    return urls[environments];
  },
  getEnvLabel: async function () {
    await this.setEnv();
    if (environments !== envP.PRD) {
      return `${environments} ENV`;
    }
    return '';
  },
};

export { environments, envP, envFunc };
